import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>403 - غير مصرح به</h1>
      <p>ليس لديك الصلاحية للوصول إلى هذه الصفحة.</p>
      <Link to="/">العودة إلى الصفحة الرئيسية</Link>
    </div>
  );
};

export default UnauthorizedPage;
